import React from "react";
import "../css/Navbar.css";

const Navbar = ({ title }) => {
  return (
    <nav className="navbar">
      <div className="navbar-title">
        <h1>{title}</h1> {/* Judul halaman menggantikan logo */}
      </div>
      <ul className="navbar-links">
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <a href="/about">About</a>
        </li>
        <li>
          <a href="/contact">Contact</a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
